import React from 'react'
import style from './style.module.less'
import { addImageView } from '@core/utils'

const Image = ({ tagText, src }) => {
  return (
    <div className={style.image}>
      {tagText && <span className={style.tag}>{tagText}</span>}
      <img width="100%" src={addImageView(src, 400)} />
    </div>
  )
}

export default Image
